import { render, staticRenderFns } from "./SelfinvoicesOther.vue?vue&type=template&id=52cf8a55&"
import script from "./SelfinvoicesOther.vue?vue&type=script&lang=js&"
export * from "./SelfinvoicesOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports